export const changeColorCoding = (errors) => {

    if ( !errors ) {
        return 
    }

    // Reiniciar
    const allCampos = document.querySelectorAll('input');
    allCampos.forEach(input => {
        input?.classList.remove('failed')
    });
    
    const allMensajes = document.querySelectorAll('[data-error]');
    allMensajes.forEach(mensaje => {
        mensaje.innerHTML = '';
        mensaje.className = '';
    })

    // Mostrar errores    
    errors.forEach(error => {
        const campo = document.querySelector(`[name=${error.param}]`);
        campo.classList.add('failed')

        const mensaje = document.querySelector(`[data-error=${error.param}]`);
        mensaje.innerHTML = error.msg;
        mensaje.className = 'mensajeError';

    });
}